export enum EmailAlertTimeOption {
    Disabled,
    Daily,
    RealTime
}